// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UserOutlinedSvg from "@fishx/icons-svg/es/asn/UserOutlined";
import FishxIcon from '../components/FishxIcon';

var UserOutlined = function UserOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: UserOutlinedSvg
  }));
};

UserOutlined.displayName = 'UserOutlined';
export default React.forwardRef(UserOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/UserOutlined.js
// module id = 4352
// module chunks = 0